// src/routes/paths.js

const ADMIN_BASE = '/admin';

export const PATHS = {
    // المسارات العامة (Public)
    FINGER: '/finger',
    LOCATION: '/location',
    LOGIN: '/login',
    PUBLIC_CONSUMER: (id) => `/consumer-protection/public/${id || ':id'}`,
    PUBLIC_ROOT: (id) => `/${id || ':id'}`,
    ESTABLISHMENT_DASHBOARD: (id) => `/establishment-dashboard/${id || ':id'}`,

    // مسارات لوحة التحكم (Admin)
    ADMIN: {
        ROOT: ADMIN_BASE,
        HOME: `${ADMIN_BASE}`,
        CHANGE_PASSWORD: `${ADMIN_BASE}/change-password`,

        // إدارة المستخدمين
        USERS: `${ADMIN_BASE}/users-management`,
        USERS_CREATE: `${ADMIN_BASE}/users-management/create`,
        USERS_EDIT: (id) => `${ADMIN_BASE}/users-management/edit/${id || ':id'}`,
        USERS_CHANGE_PW: (id) => `${ADMIN_BASE}/users-management/change-password/${id || ':userId'}`,

        // الصلاحيات والأدوار
        PERMISSIONS: `${ADMIN_BASE}/permissions-management`,
        PERMISSIONS_CREATE: `${ADMIN_BASE}/permissions-management/create`,
        ROLES: `${ADMIN_BASE}/roles-management`,
        ROLES_CREATE: `${ADMIN_BASE}/roles-management/create`,
        ROLES_EDIT: (id) => `${ADMIN_BASE}/roles-management/edit/${id || ':id'}`,

        // المنشآت
        ESTABLISHMENTS: `${ADMIN_BASE}/establishments`,
        ESTABLISHMENTS_DETAILS: (id) => `${ADMIN_BASE}/establishments/${id || ':id'}`,
        ESTABLISHMENTS_LIST: `${ADMIN_BASE}/establishments-list`,

        // الأنشطة والمخالفات
        ACTIVITIES: `${ADMIN_BASE}/activities-management`,
        ACTIVITIES_CREATE: `${ADMIN_BASE}/activities-management/create`,
        ACTIVITIES_EDIT: (id) => `${ADMIN_BASE}/activities-management/edit/${id || ':id'}`,

        VIOLATION_TYPES: `${ADMIN_BASE}/violation-types-management`,
        VIOLATION_TYPES_CREATE: `${ADMIN_BASE}/violation-types/create`,
        VIOLATION_TYPES_EDIT: (id) => `${ADMIN_BASE}/violation-types/edit/${id || ':id'}`,

        VIOLATIONS: `${ADMIN_BASE}/violations`,
        VIOLATION_DETAILS: `${ADMIN_BASE}/violation-details`,

        // الشكاوى
        COMPLAINTS: `${ADMIN_BASE}/complaints`,
        COMPLAINT_DETAILS: `${ADMIN_BASE}/complaint-details`,
        ALL_COMPLAINTS: `${ADMIN_BASE}/all-complaint`,

        // المهام والرقابة
        INSPECTION_CREATE: `${ADMIN_BASE}/inspection-mission/create`,
        FACILITY_TYPES: `${ADMIN_BASE}/facilitytypes-management`,
        FACILITY_TYPES_CREATE: `${ADMIN_BASE}/facilitytypes-management/create`,
        FACILITY_TYPES_EDIT: (id) => `${ADMIN_BASE}/facilitytypes-management/edit/${id || ':id'}`,

        // الموظفين والجداول
        PATROL_STAFF: `${ADMIN_BASE}/patrolstaff-management`,
        PATROL_STAFF_CREATE: `${ADMIN_BASE}/patrolstaff-management/create`,
        PATROL_STAFF_EDIT: (id) => `${ADMIN_BASE}/patrolstaff-management/edit/${id || ':id'}`,
        PATROL_ROSTERS: `${ADMIN_BASE}/patrol-rosters`,
        PATROL_ROSTERS_CREATE: `${ADMIN_BASE}/patrol-rosters/create`,

        // أنواع المبيعات والأسعار
        SALES_TYPES: `${ADMIN_BASE}/sales-types-management`,
        SALES_TYPES_CREATE: `${ADMIN_BASE}/sales-types-management/create`,
        SALES_TYPES_EDIT: (id) => `${ADMIN_BASE}/sales-types-management/edit/${id || ':id'}`,

        PRICE_SURVEY_PRODUCTS: `${ADMIN_BASE}/price-survey-products`,
        PRICE_SURVEY_REPORT: `${ADMIN_BASE}/price-survey-report`,
        PRICE_SURVEY_MATRIX_REPORT: `${ADMIN_BASE}/price-survey-matrix-report`,
        PRICE_AVERAGE_REPORT: `${ADMIN_BASE}/price-average-survey-report`,
        PRICE_CATEGORIES: `${ADMIN_BASE}/price-survey-categories`,

        // الزيارات والرموز
        VISITS: `${ADMIN_BASE}/visits`,
        VISIT_DETAILS: (uid) => `${ADMIN_BASE}/visit-details/${uid || ':visitUid'}`,
        GENERATE_UID: `${ADMIN_BASE}/generate-uid`,
    }
};